const actions = {
  LOAD_INITIAL_DATA: 'app/LOAD_INITIAL_DATA',

  GROUPS_RECEIVE: 'groups/GROUPS_RECEIVE',
  GROUPS_CREATE: 'groups/GROUPS_CREATE',
  GROUPS_CREATE_SUCCESSFUL: 'groups/GROUPS_CREATE_SUCCESSFUL',

  GROUP_UPDATED: 'groups/GROUP_UPDATED',
  GROUP_ADMINS_RECEIVED: 'groups/GROUP_ADMINS_RECEIVED',
  GROUP_ADMIN_UPDATED: 'groups/GROUP_ADMIN_UPDATED',

  GROUP_STATS_RECEIVED: 'groups/GROUP_STATS_RECEIVED',
}

export default actions;